var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 2H5.15625C5.03193 2 4.9127 2.05268 4.82479 2.14645C4.73689 2.24021 4.6875 2.36739 4.6875 2.5V5H2.34375C2.21943 5 2.1002 5.05268 2.01229 5.14645C1.92439 5.24021 1.875 5.36739 1.875 5.5V13.5C1.875 13.6326 1.92439 13.7598 2.01229 13.8536C2.1002 13.9473 2.21943 14 2.34375 14H9.84375C9.96807 14 10.0873 13.9473 10.1752 13.8536C10.2631 13.7598 10.3125 13.6326 10.3125 13.5V11H12.6562C12.7806 11 12.8998 10.9473 12.9877 10.8536C13.0756 10.7598 13.125 10.6326 13.125 10.5V2.5C13.125 2.36739 13.0756 2.24021 12.9877 2.14645C12.8998 2.05268 12.7806 2 12.6562 2ZM9.375 13H2.8125V6H9.375V13ZM12.1875 10H10.3125V5.5C10.3125 5.36739 10.2631 5.24021 10.1752 5.14645C10.0873 5.05268 9.96807 5 9.84375 5H5.625V3H12.1875V10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d64186c346c7ee5d2c1c207fbecde122.svg";
export { ForwardRef as ReactComponent };